"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Send, LoaderCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="34052" className="flex flex-col items-center justify-center h-full min-h-[400px] text-center p-6 space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="w-20 h-20 bg-[#2C5F63]/20 rounded-full flex items-center justify-center mb-2 text-[#2C5F63]">
          <Send className="w-10 h-10" />
        </div>
        <h3 className="text-2xl font-bold text-[#4A5D23]">Nachricht gesendet!</h3>
        <p className="text-[#333333] max-w-xs mx-auto text-lg">
          {successMessage}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <FormField control={control} name="name" rules={{
      required: "Bitte geben Sie Ihren Namen ein."
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#333333]">Ihr Name <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Input placeholder="Max Mustermann" {...field} className="bg-white border-[#E0E0E0] focus:border-[#2C5F63] focus:ring-[#2C5F63]/20 rounded-md" />
            </FormControl>
            <FormDescription className="text-[#333333]/60">Bitte geben Sie Ihren vollständigen Namen an.</FormDescription>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="email" rules={{
        required: "E-Mail-Adresse ist erforderlich.",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Bitte geben Sie eine gültige E-Mail-Adresse ein."
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#333333]">E-Mail-Adresse <span className="text-red-500">*</span></FormLabel>
              <FormControl>
                <Input type="email" placeholder="max@example.com" {...field} className="bg-white border-[#E0E0E0] focus:border-[#2C5F63] focus:ring-[#2C5F63]/20 rounded-md" />
              </FormControl>
              <FormDescription className="text-[#333333]/60">Wir kontaktieren Sie gerne per E‑Mail.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#333333]">Telefonnummer</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+49 (0) 6764 960999" {...field} className="bg-white border-[#E0E0E0] focus:border-[#2C5F63] focus:ring-[#2C5F63]/20 rounded-md" />
              </FormControl>
              <FormDescription className="text-[#333333]/60">Optional – für Rückfragen per Telefon.</FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#333333]">Betreff</FormLabel>
            <FormControl>
              <Input placeholder="Anfrage zu Tai Chi / Qi Gong …" {...field} className="bg-white border-[#E0E0E0] focus:border-[#2C5F63] focus:ring-[#2C5F63]/20 rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Bitte geben Sie eine Nachricht ein."
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[#333333]">Nachricht <span className="text-red-500">*</span></FormLabel>
            <FormControl>
              <Textarea placeholder="Schreiben Sie uns Ihr Anliegen …" className="min-h-[150px] bg-white border-[#E0E0E0] focus:border-[#2C5F63] focus:ring-[#2C5F63]/20 resize-y rounded-md" {...field} />
            </FormControl>
            <FormDescription className="text-[#333333]/60">Beschreiben Sie uns kurz, wie wir Ihnen helfen können.</FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2">
          <span className="text-lg"></span>
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-[#2C5F63] hover:bg-[#1e4144] text-white font-bold py-6 text-lg shadow-md hover:shadow-lg transition-all duration-300 mt-2 cursor-pointer rounded-md">
        {isSubmitting ? <>
            <LoaderCircle className="mr-2 h-5 w-5 animate-spin" />
            Wird gesendet...
          </> : "Nachricht senden"}
      </Button>
    </Form>;
}
export default function SchreibenSieUns() {
  return;
}